import { api } from 'utils/network/api';

export const defaultHeaders =
  typeof window !== 'undefined'
    ? {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    : {
        Authorization: ''
      };

export const doLogin = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/auth/login',
    method: 'POST',
    body: JSON.stringify(request)
  });

export const getRoles = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/role/list',
    method: 'POST',
    body: JSON.stringify(request)
  });

export const createRole = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/role/',
    method: 'POST',
    body: JSON.stringify(request)
  });

export const editRole = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/role/${request.id}`,
    method: 'PUT',
    body: JSON.stringify(request)
  });

export const deleteRole = (url, roleId) =>
  api({
    baseUrl: url,
    endpoint: `/role/${roleId}`,
    method: 'DELETE'
  });

export const getUsers = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/user/list',
    method: 'POST',
    body: JSON.stringify(request)
  });

export const createUser = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/user/',
    method: 'POST',
    body: JSON.stringify(request)
  });

export const editUser = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/user/${request.id}`,
    method: 'PUT',
    body: JSON.stringify(request)
  });

export const deleteUser = (url, roleId) =>
  api({
    baseUrl: url,
    endpoint: `/user/${roleId}`,
    method: 'DELETE'
  });

// @deprecated
export const getPoints = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/gamification/list',
    method: 'POST',
    body: JSON.stringify(request)
  });

// @deprecated
export const createPoint = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/gamification/',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

// @deprecated
export const editPoint = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/gamification/${request.id}`,
    method: 'PUT',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

// @deprecated
export const deletePoint = (url, roleId) =>
  api({
    baseUrl: url,
    endpoint: `/gamification/${roleId}`,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const getSegments = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/segment/list',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const getSegmentTargets = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/segment-target/list',
    method: 'POST',
    body: JSON.stringify(request)
  });

export const createSegment = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/segment/',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const editSegment = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/segment/${request.id}`,
    method: 'PUT',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const deleteSegment = (url, roleId) =>
  api({
    baseUrl: url,
    endpoint: `/segment/${roleId}`,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const uploadFile = (url, request, type) =>
  api({
    baseUrl: url,
    endpoint: `/bucket/upload/${type}`,
    method: 'POST',
    body: request,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const getCampaigns = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/campaign/list',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const createCampaign = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/campaign/',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const updateCampaign = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/campaign/${request.id}`,
    method: 'PUT',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const deleteCampaign = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/campaign/${request.id}`,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const deleteNotificationCampaign = (url, campaignId) =>
  api({
    baseUrl: url,
    endpoint: `/campaign/${campaignId}/clear-inbox-notification`,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const getCampaignById = (url, campaignId) =>
  api({
    baseUrl: url,
    endpoint: `/campaign/${campaignId}`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const getCampaignSummaryById = (url, campaignId) =>
  api({
    baseUrl: url,
    endpoint: `/campaign/summary/${campaignId}`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const downloadCampaignSummary = (url, campaignId, type = 'summary') =>
  api({
    baseUrl: url,
    endpoint: `/campaign/${type}/${campaignId}/download`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const getCampaignTarget = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/campaign-target/list',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const deleteCampaignTarget = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/campaign-target/${request.id}`,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const createCampaignTarget = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/campaign-target/',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const getFcmList = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/customer-fcm/list',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const createCustomerFcm = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/customer-fcm/',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const createManualCampaign = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/campaign-notif/manual',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const syncCampaignTarget = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/campaign-target/sync/${request.id}`,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const isGamificationVisible = (url, method) =>
  api({
    baseUrl: url,
    endpoint: '/gamification/is-visible',
    method: method,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const fetchGamificationList = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/gamification-new/point/list',
    body: JSON.stringify(request),
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const createGamification = (url, request) =>
  api({
    baseUrl: url,
    endpoint: '/gamification-new/point',
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const updateGamification = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/gamification-new/point/${request.id}`,
    method: 'PUT',
    body: JSON.stringify(request),
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const deleteGamification = (url, id) =>
  api({
    baseUrl: url,
    endpoint: `/gamification-new/point/${id}`,
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const fetchStores = (url, request) =>
  api({
    baseUrl: url,
    endpoint: `/shippings/v2/internal/config/stores/?${request}`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'x-project': 'dashboard'
    }
  });
